// @flow
import React from 'react';

type Props = {
  mobile: boolean,
  disabled: boolean,
  onClick: (e: MouseEvent) => void,
};

export default function SendButton(props: Props) {
  const { mobile, disabled, onClick } = props;

  return mobile ? (
    <div onClick={onClick}>
      <i className={`fas fa-paper-plane ${disabled ? 'disabled' : ''}`} />
    </div>
  ) : (
    <button className="btn btn-primary" onClick={onClick} disabled={disabled}>
      送信
    </button>
  );
}
